import React, { createContext, useContext, memo } from "react";
import { useMachine } from "@xstate/react";
import AuthMachine from "../../machines/AuthMachine";
import PropTypes from "prop-types";
const {
  machine: authMachine
} = AuthMachine;
const StateContext = /*#__PURE__*/createContext();
const DispatchContext = /*#__PURE__*/createContext(() => {});
const Provider = /*#__PURE__*/memo(({
  children,
  apiBaseUrl = "https://resource-platform-api.oneclass.com.tw",
  productApiUrl = "https://resource-library-api-dev.oneclass.com.tw"
}) => {
  const [state, send] = useMachine(authMachine, {
    context: {
      apiBaseUrl,
      productApiUrl
    }
  });
  console.log(state);
  return /*#__PURE__*/React.createElement(StateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(DispatchContext.Provider, {
    value: send
  }, children));
});

const useAuthState = () => useContext(StateContext);

const useAuthDispatch = () => useContext(DispatchContext); // const useAuth = () => {
// 	const dispatch = useAuthDispatch();
// 	const logout = () => dispatch({ type: "" });
// 	// const event = useMemo(() => ({
// 	// 	logout,
// 	// }));
// 	return {
// 		logout,
// 	};
// };


export default Provider;
export { useAuthState, useAuthDispatch };
Provider.propTypes = {
  children: PropTypes.node,
  apiBaseUrl: PropTypes.string,
  productApiUrl: PropTypes.string
};